/**
 * Motowheeler unique interactions
 * - Scroll tachometer
 * - 3D product card tilt
 * - Magnetic buttons
 * - Logo double-click "rev" easter egg
 */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTach() {
    if (reduced) return;
    const el = document.createElement('div');
    el.className = 'tach';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="tach__core"><span class="tach__rpm" data-tach-rpm>0</span><span class="tach__unit">rpm</span></div>';
    document.body.appendChild(el);

    const rpmEl = el.querySelector('[data-tach-rpm]');
    let ticking = false;

    const update = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? Math.min(1, window.scrollY / max) : 0;
      const deg = Math.round(pct * 100);
      const rpm = Math.round(pct * 9800);
      el.style.setProperty('--tach', `${deg}%`);
      rpmEl.textContent = rpm < 1000 ? String(rpm) : `${(rpm / 1000).toFixed(1)}k`;
      el.classList.toggle('is-on', window.scrollY > 80);
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  function initTilt() {
    if (reduced || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const attach = (card) => {
      if (card.dataset.tiltReady) return;
      card.dataset.tilt = '';
      card.dataset.tiltReady = '1';
      const media = card.querySelector('.product-card__media');
      if (!media) return;

      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.classList.add('is-tilting');
        media.style.transform = `rotateY(${x * 12}deg) rotateX(${-y * 10}deg) scale(1.02)`;
      });
      card.addEventListener('pointerleave', () => {
        card.classList.remove('is-tilting');
        media.style.transform = '';
      });
    };

    document.querySelectorAll('.product-card').forEach(attach);
    new MutationObserver(() => {
      document.querySelectorAll('.product-card').forEach(attach);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function initMagnetic() {
    if (reduced || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.btn--primary, .btn--orange, .btn--gold, .btn--atc').forEach((btn) => {
      btn.classList.add('btn--magnetic');
      btn.addEventListener('pointermove', (e) => {
        const r = btn.getBoundingClientRect();
        const x = e.clientX - (r.left + r.width / 2);
        const y = e.clientY - (r.top + r.height / 2);
        btn.style.transform = `translate(${x * 0.18}px, ${y * 0.22}px)`;
      });
      btn.addEventListener('pointerleave', () => {
        btn.style.transform = '';
      });
    });
  }

  function initRevEgg() {
    document.querySelectorAll('.logo-mark').forEach((logo) => {
      logo.style.cursor = 'pointer';
      logo.title = 'Double-tap to rev';
      logo.addEventListener('dblclick', (e) => {
        e.preventDefault();
        logo.classList.remove('is-revving');
        void logo.offsetWidth;
        logo.classList.add('is-revving');

        let burst = document.querySelector('.rev-burst');
        if (!burst) {
          burst = document.createElement('div');
          burst.className = 'rev-burst';
          burst.innerHTML = '<div class="rev-burst__msg">VROOOOM — engine on</div>';
          document.body.appendChild(burst);
        }
        burst.classList.add('is-on');
        setTimeout(() => burst.classList.remove('is-on'), 900);
      });
    });
  }

  function init() {
    initTach();
    initTilt();
    initMagnetic();
    initRevEgg();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
